import React from 'react'

const OrderDetailsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 60 60"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#ad6d40"
                        d="M45 53V9c0-2.2-1.8-4-4-4H5C2.8 5 1 6.8 1 9v44c0 2.2 1.8 4 4 4h36a4 4 0 0 0 4-4z"
                        opacity={1}
                        data-original="#ad6d40"
                    />
                    <rect
                        width={36}
                        height={44}
                        x={5}
                        y={9}
                        fill="#f8f8ff"
                        rx={1}
                        opacity={1}
                        data-original="#f8f8ff"
                        className=""
                    />
                    <path
                        fill="#cbcbf4"
                        d="M31 5v3c0 1.1-.9 2-2 2H17c-1.1 0-2-.9-2-2V5c0-.55.45-1 1-1h3.13c.44-1.73 2.01-3 3.87-3s3.43 1.27 3.87 3H30c.55 0 1 .45 1 1z"
                        opacity={1}
                        data-original="#cbcbf4"
                    />
                    <path
                        fill="#ea9453"
                        d="M59 29.96V57c0 1.1-.9 2-2 2H27c-1.1 0-2-.9-2-2V29.96z"
                        opacity={1}
                        data-original="#ea9453"
                        className=""
                    />
                    <path
                        fill="#fcb36b"
                        d="m58.695 29.237-5.934-5.934a1.032 1.032 0 0 0-.73-.303H31.97a1.03 1.03 0 0 0-.73.303l-5.934 5.934c-.651.651-.19 1.763.73 1.763h31.93c.92 0 1.381-1.112.73-1.763z"
                        opacity={1}
                        data-original="#fcb36b"
                    />
                    <path
                        fill="#723535"
                        d="M47 31v7a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-7l1-1h8z"
                        opacity={1}
                        data-original="#723535"
                    />
                    <rect
                        width={7}
                        height={5}
                        x={29}
                        y={50}
                        fill="#ffffff"
                        rx={1}
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#914747"
                        d="m47 31-3-8h-4l-3 8z"
                        opacity={1}
                        data-original="#914747"
                    />
                    <path
                        fill="#20295e"
                        d="M48.707 49.293a.999.999 0 0 0-1.414 0l-1 1A.999.999 0 0 0 47 52v3a1 1 0 1 0 2 0v-3a.999.999 0 0 0 .707-1.707zM55.707 50.293l-1-1a.999.999 0 0 0-1.414 0l-1 1A.999.999 0 0 0 53 52v3a1 1 0 1 0 2 0v-3a.999.999 0 0 0 .707-1.707z"
                        opacity={1}
                        data-original="#20295e"
                    />
                    <g fill="#43a867">
                        <path
                            d="M14 23a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414l1.138 1.138 3.323-4.985a.999.999 0 1 1 1.664 1.11l-4 6a1 1 0 0 1-.832.445zM14 35a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414l1.138 1.138 3.323-4.985a.999.999 0 1 1 1.664 1.11l-4 6a1 1 0 0 1-.832.445zM14 47a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414l1.138 1.138 3.323-4.985a1 1 0 1 1 1.664 1.11l-4 6a1 1 0 0 1-.832.445z"
                            fill="#43a867"
                            opacity={1}
                            data-original="#43a867"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default OrderDetailsIcon